import { render } from "./AboutS18.vue?vue&type=template&id=6321d23a&scoped=true"
import script from "./AboutS18.vue?vue&type=script&lang=js"
export * from "./AboutS18.vue?vue&type=script&lang=js"

import "./AboutS18.vue?vue&type=style&index=0&id=6321d23a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6321d23a"]])

export default __exports__